import Swal from "sweetalert2";

/**
 * Muestra una alerta o notificación modal suave, moderna y no invasiva
 * con backdrop blur y transiciones fluidas.
 */
export const notificarAdvertencia = ({
  title = "Inspección Registrada",
  message = "",
  confirmButtonText = "Entendido",
  width = "430px",
} = {}) => {
  return Swal.fire({
    html: `
      <div style="font-family: inherit; text-align: center; padding: 4px 2px 2px;">
        <!-- Badge moderno con icono de advertencia y suave resplandor -->
        <div style="width: 52px; height: 52px; margin: 0 auto 12px; background: linear-gradient(135deg, #FEF3C7 0%, #FDE68A 100%); border-radius: 50%; display: flex; align-items: center; justify-content: center; box-shadow: 0 8px 18px -4px rgba(245, 158, 11, 0.28);">
          <svg style="width: 26px; height: 26px; color: #D97706;" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"></path>
          </svg>
        </div>

        <!-- Título principal -->
        <div style="font-size: 1.18rem; font-weight: 700; color: #0F172A; margin-bottom: 8px; letter-spacing: -0.01em;">
          ${title}
        </div>

        <!-- Tarjeta de mensaje suave y legible -->
        <div style="background: #FFFBEB; border: 1px solid #FDE68A; border-radius: 12px; padding: 12px 16px; margin: 10px 0 6px; text-align: center;">
          <p style="margin: 0; font-size: 0.94rem; color: #92400E; line-height: 1.5; font-weight: 500;">
            ${message}
          </p>
        </div>
      </div>
    `,
    customClass: {
      popup: "swal2-smooth-popup",
      confirmButton: "swal2-smooth-btn",
      closeButton: "swal2-smooth-close-btn",
    },
    showClass: {
      popup: "swal2-smooth-show",
      backdrop: "swal2-smooth-backdrop-show",
    },
    hideClass: {
      popup: "swal2-smooth-hide",
      backdrop: "swal2-smooth-backdrop-hide",
    },
    buttonsStyling: false,
    showConfirmButton: true,
    confirmButtonText,
    showCloseButton: true,
    focusConfirm: true,
    allowOutsideClick: true,
    allowEscapeKey: true,
    width,
    background: "#FFFFFF",
    backdrop: "rgba(15, 23, 42, 0.32)",
  });
};
